module.exports = __webpack_public_path__ + "static/media/9D67D874-625B-4F22-8A96-4F05A6CC4CE5.86161b47.jpeg";